import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { pinia } from "./stores";
import { VuexCompatibilityPlugin } from "./vuex-compat";
import vuetify from "./plugins/vuetify";
import * as Sentry from "@sentry/vue";
import { Auth0Plugin } from "./auth";
import GlobalMixin from "./mixins/GlobalMixin";
import { getSafeInternalRoute } from "./lib/routeUtils";

import "./mixins/GlobalMixin";

const app = createApp(App);

app.mixin(GlobalMixin);
app.use(router);
app.use(pinia);
app.use(VuexCompatibilityPlugin); // Add compatibility layer for $store
app.use(vuetify);

Sentry.init({
  app,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  environment: process.env.VUE_APP_SENTRY_ENVIRONMENT,
  integrations: Sentry.browserTracingIntegration({ router }),
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

app.use(Auth0Plugin, {
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
  authorizationParams: {
    audience: process.env.VUE_APP_AUTH0_AUDIENCE,
  },
  scope:
    "profile email read:checklists edit:checklists delete:checklists read:organisations edit:organisations delete:organisations read:templates edit:templates delete:templates read:announcementCategories read:announcements edit:announcements delete:announcements",
  onRedirectCallback: (appState) => {
    const nextRoute = getSafeInternalRoute(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname,
      window.location.origin,
    );

    router.push(nextRoute).catch(() => {});
  },
});

app.mount("#app");
